import * as UserActions from "./UserActions";
import * as DashboardActions from "./DashboardActions";
import * as OrdersActions from "./OrdersActions";
import * as ProductsActions from "./ProductsActions";
import * as StatementsActions from "./StatementsActions";
import * as TransferActions from "./TransferActions";
import * as ReportsActions from "./ReportsActions";
import * as InventoryActions from "./InventoryActions";
import * as ImportActions from "./ImportActions";
import * as StockRequestActions from "./StockRequestActions";
import * as DisputesActions from "./DisputesActions";
/**
 * Makes available all the action creators we've created.
 */
export default {
  ...UserActions,
  ...DashboardActions,
  ...OrdersActions,
  ...ProductsActions,
  ...StatementsActions,
  ...TransferActions,
  ...ReportsActions,
  ...ImportActions,
  ...InventoryActions,
  ...StockRequestActions,
  ...DisputesActions
};



// WEBPACK FOOTER //
// ./src/actions/Creators.js